<template>
  <div>
    <Header :showProductTour="false" />
    <div v-if="showEditProjectModal">
      <AddProjectModal
        :modalShow="showEditProjectModal"
        title="New Project"
        @toggle="closeEditProjectModal"
        @fetch="loadProjects"
      />
    </div>

    <b-overlay :show="tableLoading" opacity="1.0">
      <ProjectList
        v-if="!tableLoading && userProjects.length > 0"
        :key="userProjects.length"
        :projects="userProjects"
        class="project-list-table"
        @deleteProject="deleteProject"
        @updateProject="updateProject"
        @newProjectBtnClicked="newProjectBtnClicked"
      />
    </b-overlay>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import ProjectList from '@/components/ProjectList.vue';
import AddProjectModal from '../components/modals/AddProjectModal.vue';
import { logError } from '@/utils/loggerUtils';
import { getCurUser } from '@/constants/fromLocalStorageConstants';

export default {
  name: 'ProjectListPage',
  components: {
    Header,
    ProjectList,
    AddProjectModal,
  },
  data() {
    return {
      projects: [],
      userInfo: null,
      showEditProjectModal: false,
      tableLoading: true,
    };
  },
  computed: {
    userProjects() {
      return this.projects;
    },
  },
  async created() {
    //vuex load user's projects
    this.loadProjects();
  },
  methods: {
    async loadProjects() {
      await this.$store.dispatch('FETCH_PROJECTS');

      const projectArray = this.$store.state.projects.projects;
      this.projects = projectArray.map(this.reOrganizeProject);

      if (this.projects) {
        this.tableLoading = false;
      }
    },
    reOrganizeProject(projectData) {
      if (!projectData.project) {
        logError(
          new Error(
            `Deleted project - User: ${getCurUser().email} Project ID: ${
              projectData && projectData.id
            }`
          )
        );
        return {};
      }

      const organizedProject = {
        projectName: projectData.text,
        projectID: projectData.projectID,
        userProjectID: projectData.id,
        searchMode:
          projectData.project.projectPreference !== undefined
            ? JSON.parse(projectData.project.projectPreference).searchMode
            : '',
        products:
          projectData.project.projectPreference !== undefined
            ? JSON.parse(projectData.project.projectPreference).products
            : [],
        owner: projectData.project.owner,
        members: projectData.project.users.items.map((item) => item.userID),
        createdTime: this.formatDate(projectData.project.createdAt),
        lastModifiedTime: this.formatDate(projectData.project.updatedAt),
        description: projectData.project.description,
      };
      return organizedProject;
    },
    async deleteProject(projectID) {
      await this.$store.dispatch('DESTROY_PROJECT', projectID);
      await this.$store.dispatch('DESTROY_USER_PROJECT', projectID);

      this.loadProjects();
    },
    async updateProject({
      projectID,
      description,
      projectName,
      inviteUsers,
      deleteUsers,
    }) {
      await this.$store.dispatch('UPDATE_PROJECT', {
        projectID,
        description,
        projectName,
        inviteUsers,
        deleteUsers,
      });

      this.loadProjects();
    },

    newProjectBtnClicked() {
      this.showEditProjectModal = true;
    },
    closeEditProjectModal() {
      this.showEditProjectModal = false;
    },
    //helpers
    formatDate(dateString) {
      return new Date(Date.parse(dateString)).toLocaleTimeString([], {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    reachProjectsQuantityLimitation() {
      if (this.projects.length < 10) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
#new-project {
  height: 3em;
}
.project-list-table {
  margin-top: 150px;
}
#project-limitation-alert {
  margin-left: 3em;
  margin-bottom: 0;
  width: 30%;
  height: 3em;
}
</style>
